import { authState } from '../../lib/auth.js';
import { BaseComponent } from '../../lib/base-component.js';
import { html } from '../../lib/lit.js';

// The staff console's sections: each link names the routes that count as being
// inside it, so the active link follows the current route.
const SECTIONS = [
    { href: '/', label: 'Invitations', routes: ['invitations'] },
    { href: '/lists', label: 'Lists', routes: ['lists', 'list-contact', 'beta-queue-entry'] },
    {
        href: '/changelog',
        label: 'Changelog',
        routes: ['changelog', 'changelog-new', 'changelog-edit'],
    },
    { href: '/polls', label: 'Polls', routes: ['polls', 'poll-new', 'poll-edit', 'poll-results'] },
    { href: '/analytics', label: 'Analytics', routes: ['analytics'] },
    { href: '/testing', label: 'Testing', routes: ['et-plans', 'et-plan', 'et-item'] },
];

// Staff-only chrome.
class AppNav extends BaseComponent {
    static properties = {
        email: { type: String },
        route: { type: String },
    };

    render() {
        return html`
            <nav class="navbar navbar-expand border-bottom bg-body-tertiary px-3">
                <a class="navbar-brand" href="/">Dice Driven Staff</a>
                <ul class="navbar-nav">
                    ${SECTIONS.map((section) => {
                        const active = section.routes.includes(this.route);
                        return html`<li class="nav-item">
                            <a
                                class="nav-link ${active ? 'active' : ''}"
                                aria-current=${active ? 'page' : 'false'}
                                href=${section.href}
                                >${section.label}</a
                            >
                        </li>`;
                    })}
                </ul>
                <div class="ms-auto d-flex align-items-center gap-3">
                    <span class="text-muted small">${this.email}</span>
                    <button class="btn btn-sm btn-outline-secondary" @click=${() => authState.logout()}>
                        Sign out
                    </button>
                </div>
            </nav>
        `;
    }
}

customElements.define('d3-app-nav', AppNav);
